import { Link, useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";

function Navbar() {
  const navigate = useNavigate();
  const { currentUser: user } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = () => {
    auth.signOut().then(() => {
      navigate("/");
      setIsMenuOpen(false);
    });
  };

  return (
    <nav className="bg-gradient-to-r from-amber-50 to-orange-100 shadow-2xl border-b-4 border-red-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20">
          {/* Logo with Korean Theme */}
          <div
            className="flex items-center space-x-2 sm:space-x-4 cursor-pointer group"
            onClick={() => navigate(user ? "/dashboard" : "/")}
          >
            <div className="relative">
              <img
                src="/korlish.png"
                alt="Korlish Logo"
                className="h-10 w-10 sm:h-14 sm:w-14 rounded-full shadow-2xl group-hover:shadow-red-500/25 transition-all duration-300 ring-2 sm:ring-4 ring-red-200"
              />
              <div className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-bold px-1 py-0.5 sm:px-2 sm:py-1 rounded-full animate-pulse">
                🇰🇷
              </div>
            </div>
            <div>
              <h1 className="text-xl sm:text-3xl font-black bg-gradient-to-r from-red-600 via-orange-500 to-amber-500 bg-clip-text text-transparent">
                Korlish
              </h1>
              <p className="text-xs text-red-600 font-bold hidden sm:block">한국어 학습</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <Link
              to="/dashboard"
              className="text-gray-800 hover:text-red-600 font-bold transition-all duration-300 hover:bg-red-50 px-4 py-3 rounded-2xl text-lg border-2 border-transparent hover:border-red-200"
            >
              Dashboard
            </Link>
            <Link
              to="/lessons"
              className="text-gray-800 hover:text-red-600 font-bold transition-all duration-300 hover:bg-red-50 px-4 py-3 rounded-2xl text-lg border-2 border-transparent hover:border-red-200"
            >
              Lessons
            </Link>
            <Link
              to="/vocab"
              className="text-gray-800 hover:text-red-600 font-bold transition-all duration-300 hover:bg-red-50 px-4 py-3 rounded-2xl text-lg border-2 border-transparent hover:border-red-200"
            >
              Vocabulary
            </Link>
            <Link
              to="/practice"
              className="text-gray-800 hover:text-red-600 font-bold transition-all duration-300 hover:bg-red-50 px-4 py-3 rounded-2xl text-lg border-2 border-transparent hover:border-red-200"
            >
              Practice
            </Link>
            <Link
              to="/culture"
              className="text-gray-800 hover:text-red-600 font-bold transition-all duration-300 hover:bg-red-50 px-4 py-3 rounded-2xl text-lg border-2 border-transparent hover:border-red-200"
            >
              Culture
            </Link>
            <Link
              to="/about"
              className="text-gray-800 hover:text-red-600 font-bold transition-all duration-300 hover:bg-red-50 px-4 py-3 rounded-2xl text-lg border-2 border-transparent hover:border-red-200"
            >
              About
            </Link>

            {/* User Actions */}
            <div className="flex items-center space-x-4 ml-6 pl-6 border-l-4 border-red-200">
              {user && (
                <Link
                  to="/profile"
                  className="text-gray-800 hover:text-red-600 font-bold transition-all duration-300 hover:bg-red-50 px-4 py-3 rounded-2xl text-lg border-2 border-transparent hover:border-red-200"
                >
                  Profile
                </Link>
              )}
              {user ? (
                <button
                  onClick={handleLogout}
                  className="bg-gradient-to-r from-red-600 to-orange-600 text-white px-6 py-3 rounded-2xl font-bold hover:from-red-700 hover:to-orange-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                >
                  Logout
                </button>
              ) : (
                <Link
                  to="/login"
                  className="bg-gradient-to-r from-red-600 to-orange-600 text-white px-6 py-3 rounded-2xl font-bold hover:from-red-700 hover:to-orange-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                >
                  Login / Sign Up
                </Link>
              )}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="p-3 text-gray-700 hover:text-red-600 focus:outline-none focus:text-red-600 transition-colors duration-200 touch-manipulation"
            >
              <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden bg-white/95 backdrop-blur-sm border-t-2 border-red-100 py-4">
            <div className="px-2 pt-2 pb-3 space-y-2">
              <Link
                to="/dashboard"
                className="block px-3 py-2 text-gray-800 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors duration-200 font-bold text-lg touch-manipulation"
                onClick={() => setIsMenuOpen(false)}
              >
                Dashboard
              </Link>
              <Link
                to="/lessons"
                className="block px-3 py-2 text-gray-800 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors duration-200 font-bold text-lg touch-manipulation"
                onClick={() => setIsMenuOpen(false)}
              >
                Lessons
              </Link>
              <Link
                to="/vocab"
                className="block px-3 py-2 text-gray-800 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors duration-200 font-bold text-lg touch-manipulation"
                onClick={() => setIsMenuOpen(false)}
              >
                Vocabulary
              </Link>
              <Link
                to="/practice"
                className="block px-3 py-2 text-gray-800 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors duration-200 font-bold text-lg touch-manipulation"
                onClick={() => setIsMenuOpen(false)}
              >
                Practice
              </Link>
              <Link
                to="/culture"
                className="block px-3 py-2 text-gray-800 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors duration-200 font-bold text-lg touch-manipulation"
                onClick={() => setIsMenuOpen(false)}
              >
                Culture
              </Link>
              <Link
                to="/about"
                className="block px-3 py-2 text-gray-800 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors duration-200 font-bold text-lg touch-manipulation"
                onClick={() => setIsMenuOpen(false)}
              >
                About
              </Link>

              {user && (
                <Link
                  to="/profile"
                  className="block px-3 py-2 text-gray-800 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors duration-200 font-bold text-lg touch-manipulation"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Profile
                </Link>
              )}

              <div className="pt-4 border-t-2 border-red-100 mt-2">
                {user ? (
                  <button
                    onClick={handleLogout}
                    className="w-full text-left block px-3 py-2 text-red-600 hover:text-red-700 hover:bg-red-50 rounded-md transition-colors duration-200 font-bold text-lg touch-manipulation"
                  >
                    Logout
                  </button>
                ) : (
                  <Link
                    to="/login"
                    className="block px-3 py-2 text-red-600 hover:text-red-700 hover:bg-red-50 rounded-md transition-colors duration-200 font-bold text-lg touch-manipulation"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Login / Sign Up
                  </Link>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;